/**
 * streamlines add a dynamic value to minHeight.
 * @param {object} param0
 * @param {string} param0.$minHeight
 * @returns {string}
 */
const dynMinHeight = ({ $minHeight }) => {
  if ($minHeight === undefined) return "";
  if (typeof $minHeight === "number") return `min-height: ${$minHeight}px;`;
  return `min-height: ${$minHeight};`;
};

export default dynMinHeight;
